module.exports = __webpack_public_path__ + "static/media/ad.2ede8484.png";